import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { Table } from 'antd'
@inject((store: any) => {
    const { insuranceCalculatorStore, popupStore, companiesStore } = store
    return { insuranceCalculatorStore, popupStore, companiesStore }
})
@observer
export default class InsurancesTable extends Component<any, any> {
    goBack = async () => {
        await this.props.insuranceCalculatorStore.clearFullReport()
        window.history.back()
    }

    checkIfIndeminficationOrCompensation = (key, value) => {
        const { insuranceCalculatorStore, mainInsuranceCases } = this.props
        const { newKefelHeser } = insuranceCalculatorStore
        const { publicPolicies } = newKefelHeser
        const rightsName =
            publicPolicies.find(policy => policy.right_param_set_id == key) &&
            publicPolicies.find(policy => policy.right_param_set_id == key).rightsName

        const publicRights =
            rightsName || (key == 14 && Object.values(value.rights).filter(right => right.exist.length)) || []
        const shabanRights = this.getRights(value)
        let privateRights = []
        mainInsuranceCases.map(insurance =>
            privateRights.push(this.getRights(value, insurance.company_id, insurance.policy_type))
        )
        let indemnification = true
        let compensation = true
        const rights = [...publicRights, ...shabanRights, ...privateRights.flat()]
        rights.map(right => {
            if (right.compensation) indemnification = false
            else if (right.indemnification) compensation = false
        })
        return indemnification ? (
            <div>
                (<span className="green">שיפוי</span>)
            </div>
        ) : compensation ? (
            <div>
                (<span className="blue">פיצוי</span>)
            </div>
        ) : (
            <div>
                (<span className="green">שיפוי</span> /<span className="blue">פיצוי</span>)
            </div>
        )
    }

    getRights = (value, company_id, policy_type) => {
        const { hmoCompanies } = this.props
        const cloneRights = value.rights ? JSON.parse(JSON.stringify(value.rights)) : []
        const rights = Object.entries(cloneRights)
            .filter(([id, right]) => {
                if (
                    (right.exist.find(policy => hmoCompanies[value.policies[policy].company_id]) ||
                        right.exist.find(policy => hmoCompanies[value.policies[policy].company_id]) == 0) &&
                    !company_id
                ) {
                    return true
                } else if (
                    (right.exist.find(
                        policy =>
                            value.policies[policy].company_id == company_id &&
                            value.policies[policy].policy_type == policy_type
                    ) ||
                        right.exist.find(
                            policy =>
                                value.policies[policy].company_id == company_id &&
                                value.policies[policy].policy_type == policy_type
                        ) == 0) &&
                    company_id
                ) {
                    return true
                }
            })
            .map(([id, right]) => {
                if (!company_id) {
                    const policy =
                        value.policies[right.exist.find(policy => hmoCompanies[value.policies[policy].company_id])]
                    right.indemnification = policy ? policy.rights[id] == 'שיפוי' : false
                    right.compensation = policy ? policy.rights[id] == 'פיצוי' : false
                } else {
                    const policy =
                        value.policies[
                            right.exist.find(
                                policy =>
                                    value.policies[policy].company_id == company_id &&
                                    value.policies[policy].policy_type == policy_type
                            )
                        ]
                    right.indemnification = policy ? policy.rights[id] == 'שיפוי' : false
                    right.compensation = policy ? policy.rights[id] == 'פיצוי' : false
                }
                return right
            })
        return rights
    }

    render() {
        const { insuranceCalculatorStore, sets, drug, mainInsuranceCases, hmoCompanies } = this.props
        const { insuranceCases, loading, newKefelHeser } = insuranceCalculatorStore
        const { publicPolicies } = newKefelHeser
        const publicName =
            hmoCompanies[
                insuranceCases.find(policy => policy.policy_type === 'PUBLIC' && hmoCompanies[policy.company_id]) &&
                    insuranceCases.find(policy => policy.policy_type === 'PUBLIC' && hmoCompanies[policy.company_id])
                        .company_id
            ]
        const shaban = insuranceCases.find(
            insurance => insurance.policy_id && 'SHABAN' === insurance.policy_type && hmoCompanies[insurance.company_id]
        )
        let publicRights = (publicPolicies && publicPolicies.map(policy => policy.rightsName)) || []
        if (insuranceCases.find(insurance => insurance.right_param_set_id == 14)) {
            publicRights.push(Object.values(newKefelHeser.sets[14].rights).filter(right => right.exist.length))
        }
        if (publicRights) publicRights = publicRights.flat()
        let shabanRights = []
        const renderSets = newKefelHeser.sets || {}
        Object.values(renderSets).map(
            set =>
                (shabanRights = [
                    ...shabanRights,
                    ...Object.values(set.rights).filter(right => {
                        if (
                            right.exist.find(policy => hmoCompanies[set.policies[policy].company_id]) ||
                            right.exist.find(policy => hmoCompanies[set.policies[policy].company_id]) == 0
                        ) {
                            return true
                        }
                    })
                ])
        )
        let privateRights = []
        mainInsuranceCases.map(() => privateRights.push([]))
        Object.values(renderSets).map(set =>
            mainInsuranceCases.map((insurance, ind) => {
                privateRights[ind] = [
                    ...privateRights[ind],
                    ...Object.values(set.rights).filter(
                        right =>
                            right.exist.find(
                                policy =>
                                    set.policies[policy].company_id == insurance.company_id &&
                                    set.policies[policy].policy_type == insurance.policy_type
                            ) ||
                            right.exist.find(
                                policy =>
                                    set.policies[policy].company_id == insurance.company_id &&
                                    set.policies[policy].policy_type == insurance.policy_type
                            ) == 0
                    )
                ]
            })
        )

        const columns = [
            {
                title: 'ביטוחים',
                key: 'right_param_set_id',
                render: (_, record) => (
                    <span>
                        {record.right_param_set_id
                            ? record.right_param_set_id != 20
                                ? sets[`id${record.right_param_set_id}`]
                                : drug
                            : 'סה״כ'}
                        {this.checkIfIndeminficationOrCompensation(record.right_param_set_id, record)}
                    </span>
                )
            },
            {
                title: `${publicName || ''}`,
                key: 'id',
                render: (_, record) => (
                    <span>
                        {record.right_param_set_id ? (
                            (publicPolicies.find(policy => policy.right_param_set_id == record.right_param_set_id) &&
                                publicPolicies.find(policy => policy.right_param_set_id == record.right_param_set_id)
                                    .rights) ||
                            (record.right_param_set_id == 14 &&
                                insuranceCases.find(insurance => insurance.right_param_set_id == 14)) ? (
                                <>
                                    <div
                                        style={{ textDecoration: 'underline', color: 'orange', cursor: 'pointer' }}
                                        onClick={() => {
                                            this.props.popupStore.togglePopup('clarification', {
                                                title: publicName,
                                                rights: publicPolicies.find(
                                                    policy => policy.right_param_set_id == record.right_param_set_id
                                                )
                                                    ? publicPolicies.find(
                                                          policy =>
                                                              policy.right_param_set_id == record.right_param_set_id
                                                      ).rightsName
                                                    : record.right_param_set_id == 14 &&
                                                      Object.values(record.rights).filter(right => right.exist.length)
                                            })
                                        }}
                                    >
                                        {publicPolicies.find(
                                            policy => policy.right_param_set_id == record.right_param_set_id
                                        )
                                            ? publicPolicies.find(
                                                  policy => policy.right_param_set_id == record.right_param_set_id
                                              ).rights
                                            : Object.values(record.rights).filter(right => right.exist.length)
                                                  .length}{' '}
                                        כיסויים
                                    </div>
                                    {record.right_param_set_id == 14 &&
                                    Object.values(record.rights).filter(right => right.exist.length)
                                        ? `${Math.round(
                                              insuranceCases.find(insurance => insurance.right_param_set_id == 14)
                                                  .policy_price
                                          )} ₪`
                                        : ''}
                                </>
                            ) : (
                                'אין'
                            )
                        ) : (
                            <>
                                <div
                                    style={{ textDecoration: 'underline', color: 'orange', cursor: 'pointer' }}
                                    onClick={() => {
                                        this.props.popupStore.togglePopup('clarification', {
                                            title: publicName,
                                            rights: publicRights
                                        })
                                    }}
                                >
                                    {publicRights.length} כיסויים
                                </div>
                                <div>
                                    {Math.round(
                                        insuranceCases
                                            .filter(insurance => insurance.policy_type === 'PUBLIC')
                                            .reduce((acc, curr) => acc + curr.policy_price, 0) +
                                            (insuranceCases.find(insurance => insurance.right_param_set_id == 14)
                                                ? insuranceCases.find(insurance => insurance.right_param_set_id == 14)
                                                      .policy_price
                                                : 0)
                                    )}
                                    ₪
                                </div>
                            </>
                        )}
                    </span>
                )
            }
        ]
        if (shaban) {
            columns.push({
                title: shaban.sub_name,
                key: shaban.sub_name,
                render: (_, record) => (
                    <span>
                        {record.rights ? (
                            this.getRights(record).length ? (
                                <div
                                    style={{ textDecoration: 'underline', color: 'orange', cursor: 'pointer' }}
                                    onClick={() => {
                                        this.props.popupStore.togglePopup('clarification', {
                                            title: shaban.sub_name,
                                            rights: this.getRights(record)
                                        })
                                    }}
                                >
                                    {this.getRights(record).length} כיסויים
                                </div>
                            ) : (
                                'אין'
                            )
                        ) : (
                            <>
                                <div
                                    style={{ textDecoration: 'underline', color: 'orange', cursor: 'pointer' }}
                                    onClick={() => {
                                        this.props.popupStore.togglePopup('clarification', {
                                            title: shaban.sub_name,
                                            rights: shabanRights
                                        })
                                    }}
                                >
                                    {shabanRights.length} כיסויים
                                </div>
                                <div>{Math.round(shaban.policy_price)} ₪</div>
                            </>
                        )}
                    </span>
                )
            })
        }
        mainInsuranceCases.map((insurance, ind) => {
            columns.push({
                title: `${insurance.name}`,
                key: ind,
                render: (_, record) => (
                    <span>
                        {record.rights ? (
                            this.getRights(record, insurance.company_id, insurance.policy_type).length ? (
                                <>
                                    <div
                                        style={{ textDecoration: 'underline', color: 'orange', cursor: 'pointer' }}
                                        onClick={() => {
                                            this.props.popupStore.togglePopup('clarification', {
                                                title: insurance.name,
                                                rights: this.getRights(
                                                    record,
                                                    insurance.company_id,
                                                    insurance.policy_type
                                                )
                                            })
                                        }}
                                    >
                                        {this.getRights(record, insurance.company_id, insurance.policy_type).length}{' '}
                                        כיסויים
                                    </div>
                                    <div>
                                        {Math.round(
                                            insuranceCases
                                                .filter(
                                                    ins =>
                                                        ins.right_param_set_id == record.right_param_set_id &&
                                                        ins.company_id == insurance.company_id &&
                                                        ins.policy_type == insurance.policy_type
                                                )
                                                .reduce((acc, curr) => acc + curr.policy_price, 0)
                                        )}
                                        ₪
                                    </div>
                                </>
                            ) : (
                                'אין'
                            )
                        ) : (
                            <>
                                <div
                                    style={{ textDecoration: 'underline', color: 'orange', cursor: 'pointer' }}
                                    onClick={() => {
                                        this.props.popupStore.togglePopup('clarification', {
                                            title: insurance.name,
                                            rights: privateRights[ind]
                                        })
                                    }}
                                >
                                    {privateRights[ind].length} כיסויים
                                </div>
                                <div>{Math.round(insurance.price)} ₪</div>
                            </>
                        )}
                    </span>
                )
            })
        })
        let rows = newKefelHeser.sets
            ? Object.entries(newKefelHeser.sets)
                  .filter(
                      ([key, value]) =>
                          (publicPolicies.find(policy => policy.right_param_set_id == key) &&
                              publicPolicies.find(policy => policy.right_param_set_id == key).rights) ||
                          (value.policies.length && Object.values(value.rights).find(right => right.exist.length))
                  )
                  .map(([key, value]) => {
                      value.right_param_set_id = key
                      return value
                  })
            : []

        if (rows.length) rows.push({})

        return (
            <Table
                className="center-table"
                style={{ width: '100%' }}
                rowKey="id"
                loading={loading}
                columns={columns}
                dataSource={rows}
            />
        )
    }
}
